import { Navigate } from 'react-router-dom';
import { Container, Row, Col, Card } from "react-bootstrap";
import { useOktaAuth } from "@okta/okta-react";

const RedirectPage = () => {
  const { authState, oktaAuth } = useOktaAuth();

  return !authState?.isAuthenticated ? (
    <Navigate to="/" />
  ) : (
    <Container>
      <Row>
        <Col className="text-center">
            <Card style={{ margin: "1em auto", height: "160px" }}>
                <Card.Header>You are Logged In</Card.Header>
                <Card.Body>
                    If you wree not logged in, you would have been redirected to the home page.
                </Card.Body>
            </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default RedirectPage;